import { calculatePctReduction } from './summaryRowCreationService.js';
import { isOfferSent } from '../utils/helpers.js';
import { usePersistedDataStore } from '../../../store.js';

export const parseRowOfferValue = (value) => {
  if (value == null || value === '' || value === 'None' || value === 'Loading...') return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const buildDerivedOfferFieldsForRow = (row, overrides = {}) => {
  const offerValue = overrides.OfferValue !== undefined
    ? parseRowOfferValue(overrides.OfferValue)
    : parseRowOfferValue(row.OfferValue);
  const townOffer = overrides.TownOffer !== undefined
    ? parseRowOfferValue(overrides.TownOffer)
    : parseRowOfferValue(row.TownOffer);
  const negotiations = overrides.Negotiations ?? row.Negotiations;

  const requestedAV = offerValue != null ? Math.round(offerValue) : null;
  const townReqAV = townOffer != null ? Math.round(townOffer) : null;
  const offerDiff = townOffer != null && offerValue != null ? townOffer - offerValue : null;

  let townPctReduction = null;
  if (townReqAV != null && row.PropertyAssessment > 0) {
    townPctReduction = ((townReqAV - row.PropertyAssessment) / row.PropertyAssessment) * 100;
  }

  const patch = {
    OfferValue: offerValue,
    TownOffer: townOffer,
    RequestedAV: requestedAV,
    TownReqAV: townReqAV,
    OfferDiff: offerDiff,
    townPctReduction,
    pctReduction: calculatePctReduction({ ...row, OfferValue: offerValue }),
    Negotiations: negotiations,
    _aventineLatestOfferSent: isOfferSent(negotiations),
  };

  if (overrides._aventineLatestOfferSent !== undefined) {
    patch._aventineLatestOfferSent = overrides._aventineLatestOfferSent;
  }

  return patch;
};

export const buildOfferRowPatchFromCase = (row, caseData) => {
  if (!caseData) return buildDerivedOfferFieldsForRow(row);
  return buildDerivedOfferFieldsForRow(row, {
    OfferValue: caseData.OfferValue,
    TownOffer: caseData.TownOffer,
    Negotiations: caseData.Negotiations,
  });
};

export const applyOfferRowPatch = (apiRef, parcelId, patch) => {
  if (!apiRef?.current || !parcelId || !patch) return;
  apiRef.current.updateRows([{ id: parcelId, ...patch }]);
};

export const refreshMunicipalOfferCard = (party) => {
  const scope = party === 'Town' ? 'town' : 'aventine';
  usePersistedDataStore.getState().refreshMunicipalResults?.({ scope });
};
